import Vue from 'vue';

import vAutoFocus from './vAutoFocus';
import vInputMask from "./vInputMask";
import vTooltip from './vTooltip';

Vue.directive('auto-focus', vAutoFocus)
Vue.directive('tooltip', vTooltip)
Vue.directive("input-mask", vInputMask);